module.exports = __webpack_public_path__ + "media/images/mypage/icon/white/ico_home-d50e0296ed4dbd07b95c32d388ac2cae.svg";